import styled from "styled-components";

export const AssetMediaTabStyled = styled.div``;

export const AssetChecklistTableWrapper = styled.div`
  margin-bottom: 20px;
  @media (max-width: 1100px) {
    .forResponsive {
      display: none;
    }
  }
`;

export const RowDiv = styled.div`
  display: grid;
  grid-template-columns: 10% 70% 20%;
  background-color: ${({ isHeader, theme }) =>
    isHeader ? theme.colors.grayL6 || "#F2F2F2" : theme.colors.grayL7 || "#FFFFFF"};
  margin-right: 1%;
  @media (max-width: 1100px) {
    display: block;
    margin-bottom: ${({ isHeader }) => (isHeader ? "0px" : "25px")};
  }
`;

export const Column = styled.div`
  border-bottom: ${({ isHeader, theme }) =>
    isHeader
      ? "0px solid " + theme.colors.grayL5 || "#CCCCCC"
      : "1px solid " + theme.colors.grayL5 || "#CCCCCC"};
  padding: 0.35rem 0.75rem 0.35rem 0.75rem;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  font-size: ${({ isHeader }) => (isHeader ? "14px" : "14px")} !important;
  font-family: ${({ isHeader }) => (isHeader ? "Kanit" : "Open Sans")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  display: ${({ isHeader }) => (isHeader ? "flex;" : "flow-root;")};
  align-items: center;
  justify-content: ${({ align }) => (align ? align : "left")};
  text-align: ${({ textleft }) => (textleft ? textleft : "left")};
  label {
    margin: 0 !important;
  }
  @media (max-width: 1100px) {
    display: ${({ isHeader }) => (isHeader ? "none;" : "block;")};
    width: ${({ widthResp }) => (widthResp ? widthResp : "75%")};
    float: ${({ floatResp }) => (floatResp ? floatResp : "left")};
    margin-right: ${({ RmarginResp }) => (RmarginResp ? RmarginResp : "5%")};
    padding: 7px;
  }
  svg {
    .cls-1 {
      fill: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
    }
  }

  .vierDeleteButton {
    display: flex;
    @media (max-width: 1100px) {
      display: block;
      float: right;
    }
  }

  // Responsive styling
  @media (max-width: 1100px) {
    display: block;
    width: 100%;
    float: none;
    margin-right: 0;
    padding: 7px;

    &:nth-child(odd) {
      text-align: right;
    }

    &:nth-child(even) {
      text-align: right;
    }
  }
`;

export const RowsContainer = styled.div`
  overflow: auto;

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.colors.grayL6 || "#F2F2F2"};
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: green !important;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.grayL4 || "#9A9A9A"};
  }

  height: ${({ isSuperAdmin }) => (isSuperAdmin ? "calc(100vh - 623px)" : "calc(100vh - 604px)")};
  @media (max-width: 1100px) {
    margin-bottom: 50px;
    height: auto;
  }
`;

export const NoSectionContainer = styled.div`
  height: ${({ isSuperAdmin }) => (isSuperAdmin ? "calc(100vh - 570px)" : "calc(100vh - 550px)")};
  display: inline-block;
  align-content: center;
  width: 100%;
  @media (max-width: 1100px) {
    height: 150px;
  }
`;
export const SpanDiv = styled.div`
  color: ${({ theme }) => theme.colors.grayL3 || "#676767"};
  text-align: center;
  font-family: "Open Sans";
  font-size: 13px !important;
  line-height: 20px;
`;

export const ButtonWrapperCol = styled.div`
  flex: 1;
  float: left;
  display: inline-flex;

  .col {
    padding-right: 0px;
  }
`;

export const ButtonWrapperRow = styled.div`
  display: flex;
  @media (max-width: 1100px) {
    ${ButtonWrapperCol} {
      &:last-child {
        flex: 2;
      }
    }
  }
`;

export const MobileResponsive = styled.div`
  display: none;
  @media (max-width: 1100px) {
    display: block;
    float: left;
    font-weight: bold;
    margin-right: 20px;
  }
`;

export const ViewIconButton = styled.a`
  font-size: 15px;
  line-height: 26px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  float: left;
  flex: 1;
  text-align: right;
  padding-right: 5px;
  :hover {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  }
`;

export const DeleteIconButton = styled.div`
  font-size: 15px !important;
  line-height: 26px;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.grayL1 || "#323232"};
  float: left;
  flex: 1;
  text-align: left;
  padding-left: 5px;
  cursor: pointer;
  :hover {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.themePrimary || "#0D5FBE"};
  }
`;
